import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "nes-select is-dark flex-1 mr-5"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 2,
  class: "nes-select is-dark flex-1 ml-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  class: "text-gray-500",
  value: null
}, "Choose wallet..", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 1,
  class: "flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.connoptions)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "nes-btn sharetech is-success",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.connoptions = true))
              }, "Connect"))
            : _createCommentVNode("", true),
          (_ctx.connoptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("select", {
                  required: "",
                  id: "cluster",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chosenCluster) = $event))
                }, [
                  _createElementVNode("option", {
                    value: _ctx.Cluster.Mainnet
                  }, "Mainnet", 8, _hoisted_3)
                ], 512), [
                  [_vModelSelect, _ctx.chosenCluster]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.connoptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                  required: "",
                  id: "wallet",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chosenWallet) = $event))
                }, [
                  _hoisted_5,
                  _createElementVNode("option", {
                    value: _ctx.WalletName.Phantom
                  }, "Phantom", 8, _hoisted_6),
                  _createElementVNode("option", {
                    value: _ctx.WalletName.Sollet
                  }, "Sollet", 8, _hoisted_7),
                  _createElementVNode("option", {
                    value: _ctx.WalletName.SolletExtension
                  }, "Sollet Extension", 8, _hoisted_8),
                  _createElementVNode("option", {
                    value: _ctx.WalletName.Solflare
                  }, "Solflare", 8, _hoisted_9),
                  _createElementVNode("option", {
                    value: _ctx.WalletName.SolflareWeb
                  }, "Solflare Web", 8, _hoisted_10)
                ], 512), [
                  [_vModelSelect, _ctx.chosenWallet]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "nes-btn sharetech is-error",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chosenWallet = null))
          }, _toDisplayString(_ctx.pubKey) + "... Disconnect", 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}